<template>
	<div class="order-note bg-white">
		<div class="success">
			<img src="/static/img/payicon.png">
			<div class="message blue">支付成功</div>
			<div class="tip">系统检测到您已完成《投资者风险承受能力问卷》的填写. 加油, 只需签订<div class="blue">电子合同</div>就可以完成订单</div>
			<div class="actions">
				<mt-button type="primary" @click="toSign">去签订</mt-button>
			</div>
		</div>
	</div>
</template>

<script>
import { Button } from 'mint-ui'

export default {
	name: 'OrderContract',
	data: () => ({
	}),
	computed: {
	},
	created () {
	},
	components: {
		'mt-button': Button
	},
	mounted: function () {
		this.setPageTitle('问卷调查')
	},
	methods: {
		toSign () {
			this.$router.push('/orders/complete/' + this.$route.params.id)
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// OrderContract.vue?8e7c53fc